import React, { useState } from 'react';
import Grid from "@mui/material/Grid";
import {
    Text,
    Modal,
    TextInput
} from '@simplybenefits/sb-ui-library';

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const ChangeRequestFiltersModal = ({ open, close, filters, setFilters, defaultFilters, statuses, assignedToMap, types }) => {
    const [ selectedFilters, setSelectedFilters ] = useState(filters);

    /**
     * apply the selected filters by setting them in the parent component state
     */
    const applyFilters = () => {
        setFilters({ ...filters, ...selectedFilters });
        close();
    };

    /**
     * remove the selected filters by setting the default filters in the parent component state
     */
    const resetFilters = () => {
        setSelectedFilters(defaultFilters());
        setFilters(defaultFilters());
        close();
    };
   
    return (
        <Modal
            title={'Filter and Sort'}
            open={open}
            onClose={close}
            primaryButton={{
                label: 'Apply Filters',
                onClick: applyFilters
            }}
            secondaryButton={{
                label: 'Reset Filters',
                onClick: resetFilters
            }}
        >
            <Grid
                container
                direction="row"
                alignItems="center"
                style={{
                    marginBottom: 20
                }}
            >
                <Text>Requested Change</Text>
                <TextInput
                    label="Requested Change"
                    fullWidth
                    value={ selectedFilters.type }
                    variant="outlined"
                    onChange={(e) => setSelectedFilters({ ...filters, type: e.target.value })}
                    select
                    selectOptions={ [ 'All', ...types ] }
                />
            
                <Text>Sort Direction</Text>
                <TextInput
                    label="Sort By"
                    fullWidth
                    value={ selectedFilters.sortDirection }
                    variant="outlined"
                    onChange={(e) => setSelectedFilters({ ...filters, sortDirection: e.target.value })}
                    select
                    selectOptions={[
                        'ASC',
                        'DESC'
                    ]}
                />

                <Text>Sort By</Text>
                <TextInput
                    label="Sort By"
                    fullWidth
                    value={ selectedFilters.sortBy }
                    variant="outlined"
                    onChange={(e) => setSelectedFilters({ ...filters, sortBy: e.target.value })}
                    select
                    selectOptions={[
                        'Submission Date',
                        'Date Signed',
                        'Status',
                        'Submitted By'
                    ]}
                />

                <Text>Submitted By</Text>
                <TextInput
                    label="Submitted By"
                    fullWidth
                    value={ selectedFilters.submittedBy }
                    variant="outlined"
                    onChange={(e) => setSelectedFilters({ ...filters, submittedBy: e.target.value })}
                    select
                    selectOptions={[
                        'All',
                        'Administrator',
                        'Member'
                    ]}
                />

                <Text>Status</Text>
                <TextInput
                    label="Status"
                    fullWidth
                    value={ selectedFilters.status }
                    variant="outlined"
                    onChange={(e) => setSelectedFilters({ ...filters, status: e.target.value })}
                    select
                    selectOptions={ [ 'All', ...statuses ] }
                />

                <Text>Assigned To</Text>
                <TextInput
                    label="Assigned To"
                    fullWidth
                    value={ selectedFilters.assignedTo }
                    variant="outlined"
                    onChange={(e) => setSelectedFilters({ ...filters, assignedTo: e.target.value })}
                    select
                    selectOptions={ [ 'All', ...Object.keys(assignedToMap) ] }
                />
            </Grid>
        </Modal>
    );
};

export default ChangeRequestFiltersModal;